export const getSquadCasesCount = userIdList => `
SELECT
    count(Id)
FROM
    Case
WHERE
    OwnerId IN (${userIdList.map(userId => `'${userId}'`).join(', ')})
    AND Status NOT IN ('Resolvido', 'Fechado', 'Closed as Duplicate', 'Closed', 'Merged')
`;
